// src/pages/passport/StepPayment.jsx
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PaymentPage from "../../Pages/PaymentPage";

export default function StepPayment({ data: propData }) {
  const location = useLocation();
  const navigate = useNavigate();

  // Handle both data structures - from CitizenPortal and from props
  const data = propData ?? location.state?.data ?? location.state?.applicationData;
  const userData = location.state?.userData;
  const paymentStatus = location.state?.paymentStatus;
  const applicationNumber = location.state?.applicationNumber;
  const showPaymentAlert = location.state?.showPaymentAlert;

  // Optional: if user refreshed / opened directly, send them back to CitizenPortal
  useEffect(() => {
    if (!data && !userData) {
      console.log("⚠️ No data found, redirecting to application");
      navigate("/passport/application", { replace: true });
    }
  }, [data, userData, navigate]);

  if (!data && !userData) {
    console.log("⚠️ Rendering null while redirecting");
    return null; // short-circuit while redirecting
  }

  // Get service type from either data structure
  const serviceType = data?.serviceType ?? data?.service_type ?? "Normal";
  const fee = serviceType === "Urgent" ? 15000 : 10000;

  console.log("💳 StepPayment rendering with:");
  console.log("   - Data:", data);
  console.log("   - Service Type:", serviceType);
  console.log("   - Fee:", fee);
  console.log("   - Payment Status:", paymentStatus);
  console.log("   - Application Number:", applicationNumber);
  console.log("   - Show Payment Alert:", showPaymentAlert);

  // Check if we should show payment alert
  const shouldShowAlert = showPaymentAlert || paymentStatus === 'pending' || paymentStatus === 'failed';

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Payment Alert Message - Show at top if payment is pending/failed */}
      {shouldShowAlert && (
        <div className="border-b border-yellow-200 bg-yellow-50">
          <div className="px-4 py-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
            <div className="flex flex-wrap items-center justify-between">
              <div className="flex items-center flex-1 min-w-0">
                <div className="flex-shrink-0">
                  <svg className="w-5 h-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                </div>
                <div className="ml-3">
                  <h3 className="text-sm font-medium text-yellow-800">
                    Payment Required
                  </h3>
                  <div className="mt-1 text-sm text-yellow-700">
                    <p>
                      Your application {applicationNumber} was successfully submitted but payment has not been made.
                      Your application cannot be processed further until the payment is completed.
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex-shrink-0 ml-4">
                <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium capitalize ${paymentStatus === 'failed'
                  ? 'bg-red-100 text-red-800'
                  : 'bg-yellow-100 text-yellow-800'
                  }`}>
                  {paymentStatus} payment
                </span>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Payment Page Component */}
      <PaymentPage
        fee={fee}
        serviceType={serviceType}
        formData={data}
        userData={userData}
        paymentStatus={paymentStatus}
        applicationNumber={applicationNumber}
      />
    </div>
  );
}